import { create } from 'zustand';
import { DEFAULT_PASSAGE_MIN_WORDS, DEFAULT_PASSAGE_MAX_WORDS } from '@/constants/passage';
import api from '@/services/api';

// Public site settings from /api/settings/public (seeded from session-init on
// authenticated pages): passage word limits and whether the one-click mock exam
// menu is shown to this viewer. The server answers for the signed-in account:
// true while the admin switch is On, and for a listed test account while it is Off.
interface PassageLimitsState {
  minWords: number;
  maxWords: number;
  /** Off until the server reports a real `true` (fails closed for non-admins). */
  oneClickMenuPublic: boolean;
  loaded: boolean;
  fetchLimits: (force?: boolean) => Promise<void>;
}

export const usePassageLimitsStore = create<PassageLimitsState>((set, get) => ({
  minWords: DEFAULT_PASSAGE_MIN_WORDS,
  maxWords: DEFAULT_PASSAGE_MAX_WORDS,
  oneClickMenuPublic: false,
  loaded: false,

  fetchLimits: async (force = false) => {
    if (get().loaded && !force) return;
    try {
      const res = await api.get('/api/settings/public');
      set({
        minWords: res.data.passage_min_words ?? DEFAULT_PASSAGE_MIN_WORDS,
        maxWords: res.data.passage_max_words ?? DEFAULT_PASSAGE_MAX_WORDS,
        oneClickMenuPublic: res.data.oneclick_mocktest_menu_public === true,
        loaded: true,
      });
    } catch {
      // Use defaults on error
      set({ loaded: true });
    }
  },
}));
